export const fieldNames = {
  tenant: 'tenantId',
  personalAccount: 'account',
  beginDate: 'startDate',
};
